export default {"src":"/_next/static/media/FeaturedIcon2.9debeae2.svg","height":28,"width":28};